<template>
  <div>
    <header-nav :show-menu="false"></header-nav>
    <section class="card-body-section">
      <div class="gradiant-banner">
        <b-container>
          <h4 class="title text-white">{{ title }}</h4>
        </b-container>
      </div>
      <b-container>
        <div class="card-content">
          <slot />
        </div>
      </b-container>
    </section>
    <main-footer></main-footer>
  </div>
</template>

<script>
import HeaderNav from "../components/Header/Header";
import MainFooter from "../components/Footer/Footer";
export default {
  name: "cardbody",
  components: {
    MainFooter,
    HeaderNav
  },
  props: {
    title: {
      default: "Default text ",
      type: String
    }
  },
  data() {
    return {
      // title: "Contribute as a teacher and earn money"
    };
  },
  methods: {
    changeTitle(e) {
      console.error("event new ", e);
      this.title = e;
    }
  }
};
</script>

<style></style>
